/**
 * Created by marco on 28/03/2020.
 *
 * (C) Copyright Fing
 */

import React, {Component} from 'react';

export default class AccountMonitoringAgentsSummary extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.fetchAgents();
    }

    fetchAgents() {
        fetch(`/rest/users/monitoring-agents`)
            .then(response => this.validateRestResponse(response))
            .then(response => response.json())
            .then(result => {
                if (result && Array.isArray(result)) {
                    this.setState({agents: result});
                }
            })
            .catch(e => {
                this.setState({agents: []});
            });
    }

    validateRestResponse(response) {
        if (response.status !== 200) {
            throw Error(response.statusText);
        }
        return response;
    }

    catchRestError(error) {
        console.error('[AccountMonitoringAgentsSummary] - ', error)
    }

    render() {
        const {userProfile} = this.props;
        let maxAgents = 0;
        if (userProfile && userProfile.permissions) {
            const activateAgentPerm = userProfile.permissions.find(perm => perm.id === "activate_agent" && perm.allowed === true);
            if (activateAgentPerm && activateAgentPerm.constraints && activateAgentPerm.constraints.max_amount) {
                maxAgents = activateAgentPerm.constraints.max_amount;
            }
        }
        const usedAgents = this.state.agents && this.state.agents.filter(a => a.type !== "fingbox").length || 0;

        const types = {
            desktop: "Desktop",
            agent: "Agent",
            fingbox: "Fingbox",
        }
        return <>
            {maxAgents > 0 && usedAgents > maxAgents &&
                <div className="alert alert-warning media" role="alert">
                    <i className="fas fa-exclamation-triangle mt-1 mr-4"></i>
                    <div className="media-body" role="alert">
                        <h4>You've Exceeded Your Subscription Limit</h4>
                        Your current plan allows monitoring of up to {maxAgents} networks, but you're currently
                        monitoring {usedAgents}. To continue without interruption, please upgrade your subscription or
                        reduce the number of monitored networks.<br/>
                        {/*<a href={"https://help.fing.com"} target={"_blank"} rel={"noopener noreferrer"}>Learn more</a>*/}
                    </div>
                </div>
            }
            <div className="card card-bordered">
            <table className="table table-sm">
                <thead>
                <tr>
                    <th>Type</th>
                    <th>Network</th>
                    <th>ID</th>
                    <th>Platform</th>
                    <th>Last update</th>
                </tr>
                </thead>
                <tbody>
                {this.state.agents && this.state.agents.map(agent => <tr key={agent.clientId || agent.agentId}>
                    <td>
                        {types[agent.type] || ""}
                    </td>
                    <td>
                        {agent.networkName}
                    </td>
                    <td>
                        {agent.clientId}
                    </td>
                    <td>
                        {agent.hardwarePlatform}
                    </td>
                    <td>
                        {agent.lastUpdateTime && new Date(agent.lastUpdateTime).toLocaleDateString()}
                    </td>
                </tr>)}
                </tbody>
            </table>
        </div>

        </>;
    }

}